interface UseCaseCardProps {
  title: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
  isFirst: boolean;
}

export default function UseCaseCard({
  title,
  description,
  isSelected,
  onClick,
  isFirst
}: UseCaseCardProps) {
  return (
    <div
      className={`p-4 pb-5 rounded-2xl cursor-pointer border-[1.6px] transition-all duration-300 ease-in-out ${isSelected
        ? "bg-blue-50 border-blue-500 text-gray-900"
        : "bg-white border-white hover:bg-gray-100 text-gray-700"
        } ${isFirst && !isSelected ? "border-blue-500" : ""}`}
      onClick={onClick}
    >
      <h3
        className={`font-medium text-lg sm:text-xl mb-2 ${isSelected ? "text-blue-600" : ""
          }`}
      >
        {title}
      </h3>
      <p
        className={`text-base sm:text-lg opacity-80 ${isSelected ? "text-gray-800" : ""
          }`}
      >
        {description}
      </p>
    </div>
  );
}
